
import { defineComponent, onMounted } from 'vue';
import { AppFormRow, AppInput, AppCard, AppSwitch, AppButton, AppImageHolder, AppFileUpload } from '@/components';
import { useSurpriseItemEdit } from '@/modules/surprise/category/item/model/edit';
import { ROUTE_NAME_SURPRISE } from '@/modules/surprise/router';

export default defineComponent({
    name: ROUTE_NAME_SURPRISE.CATEGORY.ITEM.EDIT,
    components: { AppFormRow, AppInput, AppCard, AppSwitch, AppButton, AppImageHolder, AppFileUpload },
    setup() {
        const { model, v$, fetch, actions } = useSurpriseItemEdit();

        onMounted(() => {
            fetch();
        });

        return { v$, model, actions };
    }
});
